<!--
 * @Description: 投放线索(谷仓市场/云途市场)
 * @Author: cxh
 * @Date: 2022-05-07 17:55:14
 * @LastEditTime: 2023-04-20 14:31:20
 * @LastEditors: cxh
-->
<template>
  <div style="display: inline-block; margin-right: 10px">
    <a-button @click="showModal">
      <slot></slot>
    </a-button>
    <cos-modal
      v-model:visible="visible"
      title="投放"
      class="cluePush"
      width="1200px"
      @ok="handleSubmit"
      :confirmLoading="loading"
    >
      <a-form :model="form" ref="formRef" v-if="visible" class="launchTable">
        <cos-table
          :columns="columns"
          rowKey="pageId"
          :dataSource="form.batch"
          :needPage="false"
          ref="tableRef"
          :loading="loading"
          tableId="launchTable"
        >
          <template #bodyCell="{ column, record, index }">
            <template v-if="column.dataIndex === 'receiver'">
              <a-form-item
                :name="['batch', index, 'receiver']"
                :rules="{
                  required: true,
                  message: '请选择'
                }"
              >
                <CosSelect :options="acceptClueSystem" v-model:value="record.receiver" :allowClear="false" @change="targetChange(record)"/>
              </a-form-item>
            </template>
            <template v-if="column.dataIndex === 'customerRegion'">
              <a-form-item
                :name="['batch', index, 'customerRegion']"
                :rules="{
                  required: record.receiver === 'cos_fbu' ? true : false,
                  message: '请选择'
                }"
              >
                <CustomerAreaCascader
                  appId="cos_fbu"
                  deptInfoId="815717"
                  v-model:value="record.customerRegion"
                  placeholder="请选择客户区域"
                  @change="(value) => regionChange(record,value)"
                />
              </a-form-item>
            </template>
            <template v-if="column.dataIndex === 'conductor'">
              <a-form-item
                :name="['batch', index, 'conductor']"
                :rules="{
                  required: true,
                  message: '请选择'
                }"
              >
                <BatchUserList
                  v-model:value="record.conductor"
                  v-model:label="record.conductorName"
                  placeholder="请选择"
                  allowClear
                />
              </a-form-item>
            </template>
            <template v-if="column.dataIndex === 'follower'">
              <a-form-item :name="['batch', index, 'follower']">
                <BatchUserList
                  v-model:value="record.follower"
                  v-model:label="record.followerName"
                  placeholder="请选择"
                  @change="(value) => principalChange(record,value)"
                  allowClear
                />
              </a-form-item>
            </template>
            <template v-if="column.dataIndex === 'action'">
              <a-button type="link" @click="handleDelete(index)"> 删除 </a-button>
            </template>
          </template>
        </cos-table>
      </a-form>
    </cos-modal>
  </div>
</template>
<script lang="ts" setup>
import { ref, computed, watch } from 'vue'
import { DcMessage } from '@dc-platform/dc-components'
import { cluePush } from '@/api/marketing/marketingManage'
import type { ClueManage } from '@/typings/api/marketingManage'
import type { PropType } from 'vue'
import CustomerAreaCascader from '@/components/CustomerAreaCascader/index.vue'
import BatchUserList from '../BatchUserList/index.vue'
import { cloneDeep } from 'lodash-es'
import { bool } from 'vue-types'
import { shareInfo } from '@dc-platform/dc-interaction'
const props = defineProps({
  data: {
    type: Array as PropType<ClueManage[]>,
    default: () => {
      return []
    }
  },
  type: {
    type: String,
    default: 'customer' // customer 客户 clue 线索
  },
  title: {
    type: String
  },
  tips: {
    type: String // 描述
  },
  appId: {
    type: String,
    default: 'cos_fbu'
  }
})
const visible = ref<boolean>(false)
const loading = ref<boolean>(false)
const formRef = ref()
const form = ref<any>({})
const emit = defineEmits(['success'])
const loginUser = shareInfo.getUserInfo() || {}
const acceptClueSystem = computed(() => {
  if (props.appId === 'cos_fbu') {
    return [
      {
        value: 'cos_fbu',
        label: '谷仓'
      },
      {
        value: 'cos_ofbu',
        label: '谷仓海外'
      }
    ]
  }
  return [
    {
      value: 'cos_lbu',
      label: '云途'
    }
  ]
})
const handleSubmit = () => {
  formRef.value?.validate().then(async () => {
    form.value.batch.principalRegion = undefined
    loading.value = true
    savePeopleMessage()
    cluePush({ batch: form.value.batch })
      .then(() => {
        visible.value = false
        emit('success')
        DcMessage.success('投放处理中，结果稍后通过飞书消息提醒')
      })
      .finally(() => {
        loading.value = false
      })
  })
}
// 保存人员信息到本地
const savePeopleMessage = () => {
  const { conductor, follower, customerRegion } = form.value.batch[0]
  let init = {}
  if (!loginUser.work_code) {
    return
  }
  const leadManagePeople = localStorage.getItem('dc-cos-lbu-leadManage')
  if (leadManagePeople) {
    init = JSON.parse(leadManagePeople)
  }
  if (!init[loginUser.work_code]) {
    init[loginUser.work_code] = {}
  }
  init[loginUser.work_code][props.appId] = {
    conductor,
    follower,
    customerRegion
  }
  localStorage.setItem('dc-cos-lbu-leadManage', JSON.stringify(init))
}
const showModal = () => {
  // 验证数量
  if (!props.data || props.data.length < 1) {
    DcMessage.error('请选择数据！')
    return
  }
  // 谷仓市场线索投放不过滤线索类型
  if (props.appId !== 'cos_fbu') {
    const errorData = props.data.find((item) => item.clueType !== 2)
    if (errorData) {
      DcMessage.error('请选择有效线索进行投放！')
      return
    }
  }
  form.value.batch = []
  // 验证线索 已投放到两个端的不能投放
  visible.value = true
  // 设置clueIdList
  // 处理数组（对接人字段取创建人）
  // 处理加载
  const result = props.data.reduce((prev: any, cur: any) => {
    const { expectPushInfo, createBy, createByName, clueId, customerName, receiver } = cur
    const newInfo = []
    const init = {
      cos_lbu: {
        code: 'zt20309',
        name: '李科燕'
      },
      cos_fbu: {
        code: 'zt18054',
        name: '覃恒梅'
      }
    }
    if (expectPushInfo && expectPushInfo.length) {
      expectPushInfo.forEach((e: any, i: number) => {
        newInfo.push({
          conductor: createBy,
          conductorName: createByName,
          customerRegion: e.region,
          receiver: e.acceptor ? e.acceptor : props.appId,
          subdomain: e.acceptor ? e.acceptor : props.appId,
          follower: e.follower,
          followerName: e.followerName,
          clueId,
          pageId: clueId + '_' + i,
          customerName
        })
      })
    } else {
      // 没有预投放信息的话获取默认配置
      let initPeople = {
        conductor: init[props.appId].code,
        conductorName: init[props.appId].name,
        follower: undefined,
        customerRegion: undefined
      }
      const leadManagePeople = localStorage.getItem('dc-cos-lbu-leadManage')
      if (leadManagePeople) {
        const leadManagePeopleObj = JSON.parse(leadManagePeople)
        const userConductor = leadManagePeopleObj[loginUser.work_code]
        if (userConductor && userConductor[props.appId]) {
          initPeople = userConductor[props.appId]
        }
      }
      newInfo.push({
        customerName,
        clueId,
        follower: initPeople.follower,
        customerRegion: initPeople.customerRegion,
        conductor: initPeople.conductor,
        conductorName: initPeople.conductorName,
        receiver: receiver,
        subdomain: receiver,
        pageId: clueId
      })
    }
    return [...prev, ...newInfo]
  }, [])
  loading.value = true
  setTimeout(() => {
    form.value.batch = cloneDeep(result)
    loading.value = false
  }, 500)
}
// 删除
const handleDelete = (index: number) => {
  form.value.batch.splice(index, 1)
}
/// 选择负责人后吧该负责人的区域带出来
const principalChange = (record: any, user: any) => {
  if (props.appId === 'cos_fbu' && user) {
    record.principalRegion = user.deptId
    record.customerRegion = user.deptId
  }
}
/// 谷仓为了选择区域后把不是该区域的负责人给清空
const regionChange = (record: any, region: any) => {
  if (props.appId === 'cos_fbu' && region && region.custom && region.custom !== record.principalRegion) {
    record.follower = undefined
    record.followerName = undefined
  }
}
const targetChange = (record: any) => {
  if (props.appId === 'cos_fbu' && record && record.receiver) {
    record.subdomain = record.receiver
  }
}
const columns = computed(() => {
  const init = [
    {
      title: '客户名称',
      dataIndex: 'customerName'
    },
    {
      title: '投放到',
      dataIndex: 'receiver',
      width: 100
    },
    {
      title: '客户区域',
      dataIndex: 'customerRegion',
      width: 140
    },
    {
      title: '对接人',
      dataIndex: 'conductor',
      width: 120
    },
    {
      title: '客户负责人',
      dataIndex: 'follower',
      width: 120
    },
    {
      title: '操作',
      dataIndex: 'action',
      fixed: 'right',
      width: 70
    }
  ]
  if (props.appId === 'cos_fbu') {
    return init
  } else {
    return init.filter((v) => v.dataIndex !== 'customerRegion')
  }
})
</script>
<script lang="ts">
export default { name: 'LaunchButton' }
</script>
<style lang="scss" scoped>
.cluePush {
  .list {
    margin: 20px 0;
    li {
      display: flex;
      align-items: center;
    }
    .name {
      flex: 1;
      text-align: left;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
.flex1 {
  flex: 1;
}
.launchTable {
  :deep(.ant-table .ant-form-item.ant-form-item-has-error) {
    margin-bottom: 0;
  }
  :deep(.ant-form-item-explain-error) {
    display: none;
  }
}
</style>
